module.exports = __webpack_public_path__ + "img/wink.886bada0.svg";